import React, { useEffect } from 'react'
import { Spin } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../store/auth'

export default function LoginPage() {
  const { setUserFromToken } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')
    const name = params.get('name')
    const role = params.get('role')
    const id = params.get('id')
    if (token && name && role && id) {
      localStorage.setItem('token', token)
      document.cookie = `puc_token=${token}; max-age=${7 * 86400}; path=/; SameSite=Lax; Secure`
      setUserFromToken({ id: Number(id), name, role: role as any, username: name, status: 1 })
      navigate('/', { replace: true })
    }
  }, [location.search, navigate, setUserFromToken])

  const isCallback = !!new URLSearchParams(location.search).get('token')

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #536DFE 0%, #9013FE 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* 装饰圆 */}
      <div style={{ position: 'absolute', top: -100, left: -100, width: 400, height: 400,
        borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />
      <div style={{ position: 'absolute', bottom: -80, right: -80, width: 300, height: 300,
        borderRadius: '50%', background: 'rgba(255,194,96,0.15)' }} />

      <div style={{
        width: 400, padding: 40, background: '#fff', borderRadius: 16,
        boxShadow: '0 20px 60px rgba(83, 109, 254, 0.3)', textAlign: 'center', zIndex: 1,
      }}>
        <div style={{
          width: 64, height: 64, borderRadius: 16, margin: '0 auto 20px',
          background: 'linear-gradient(135deg, #536DFE 0%, #9013FE 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontSize: 24, fontWeight: 700, boxShadow: '0 8px 16px rgba(83,109,254,0.3)',
        }}>
          PUC
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#4A4A4A', marginBottom: 4 }}>付费运营中心</div>
        <div style={{ color: '#B9B9B9', fontSize: 13, marginBottom: 32 }}>Paid User Center</div>

        {isCallback ? (
          <div style={{ padding: '24px 0' }}>
            <Spin /> <span style={{ marginLeft: 8, color: '#6E6E6E' }}>登录中...</span>
          </div>
        ) : (
          <>
            <button
              onClick={() => window.location.href = '/api/feishu/login'}
              style={{
                width: '100%', height: 48, border: 'none', borderRadius: 10,
                background: 'linear-gradient(90deg, #536DFE 0%, #798DFE 100%)',
                color: '#fff', fontSize: 15, cursor: 'pointer', fontWeight: 600,
                boxShadow: '0 4px 12px rgba(83,109,254,0.35)',
                transition: 'transform 0.2s',
              }}
              onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.98)')}
              onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
            >
              飞书账号登录
            </button>
            <div style={{ color: '#B9B9B9', fontSize: 12, marginTop: 16 }}>仅限授权飞书账号登录</div>
          </>
        )}
      </div>
    </div>
  )
}
